// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  padding: 20px;
}

.card {
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* pushes button to bottom */
  border-top: 5px solid #1a73e8;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.1);
  transition: transform 0.2s, box-shadow 0.2s;
}


.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.15);
}

.card-icon {
  margin-bottom: 12px;
}

.card-title {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 600;
}

.card-tagline {
  margin: 4px 0 12px;
  font-size: 0.95rem;
  color: #555;
}

.card-text {
  font-size: 0.9rem;
  color: #333;
  margin-bottom: 10px;
}

.card-price {
  font-weight: 500;
  margin-bottom: 4px;
}

.card-url {
  font-size: 0.8rem;
  color: #777;
  word-break: break-word;
}

.btn-register {
  background-color: #1a73e8;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.btn-register:hover {
  background-color: #155ab6;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  width: 320px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.2);
}

.modal input {
  width: 100%;
  padding: 8px 12px;
  margin: 6px 0;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.modal-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
}

.modal button {
  padding: 8px 12px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
}

.modal button[type="submit"] {
  background-color: #1a73e8;
  color: #fff;
}

.modal button[type="submit"]:hover {
  background-color: #155ab6;
}

.modal button[type="button"] {
  background-color: #ccc;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ProductPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B,EAAE,4BAA4B;EAC5D,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;EACtC,2CAA2C;AAC7C;;;AAGA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".products-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 20px;\n  padding: 20px;\n}\n\n.card {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between; /* pushes button to bottom */\n  border-top: 5px solid #1a73e8;\n  background: #fff;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 6px 18px rgba(0,0,0,0.1);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n\n.card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 25px rgba(0,0,0,0.15);\n}\n\n.card-icon {\n  margin-bottom: 12px;\n}\n\n.card-title {\n  margin: 0;\n  font-size: 1.4rem;\n  font-weight: 600;\n}\n\n.card-tagline {\n  margin: 4px 0 12px;\n  font-size: 0.95rem;\n  color: #555;\n}\n\n.card-text {\n  font-size: 0.9rem;\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.card-price {\n  font-weight: 500;\n  margin-bottom: 4px;\n}\n\n.card-url {\n  font-size: 0.8rem;\n  color: #777;\n  word-break: break-word;\n}\n\n.btn-register {\n  background-color: #1a73e8;\n  color: #fff;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.btn-register:hover {\n  background-color: #155ab6;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0,0,0,0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n.modal {\n  background: #fff;\n  padding: 24px;\n  border-radius: 12px;\n  width: 320px;\n  box-shadow: 0 6px 18px rgba(0,0,0,0.2);\n}\n\n.modal input {\n  width: 100%;\n  padding: 8px 12px;\n  margin: 6px 0;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n}\n\n.modal-buttons {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 12px;\n}\n\n.modal button {\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n}\n\n.modal button[type=\"submit\"] {\n  background-color: #1a73e8;\n  color: #fff;\n}\n\n.modal button[type=\"submit\"]:hover {\n  background-color: #155ab6;\n}\n\n.modal button[type=\"button\"] {\n  background-color: #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
